import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

interface PrivacyVersionLayoutProps {
  version: string
  date: string
  children: React.ReactNode
  isArchived?: boolean
}

export default function PrivacyVersionLayout({ 
  version, 
  date, 
  children, 
  isArchived = true 
}: PrivacyVersionLayoutProps) {
  return (
    <div className="min-h-screen">
      {/* Header Section */}
      <section className="bg-gradient-to-br from-primary/10 via-primary/5 to-white pt-32 pb-16">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto text-center"
          >
            {isArchived && (
              <div className="mb-4">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-amber-100 text-amber-800">
                  Versione Archiviata
                </span>
              </div>
            )}
            <h1 className="text-4xl md:text-5xl font-display font-bold text-dark mb-4">
              Informativa Privacy
            </h1>
            <p className="text-dark-500 text-lg">
              Versione {version} - Aggiornata al {date}
            </p>
            {isArchived && (
              <p className="mt-4">
                <Link 
                  to="/privacy" 
                  className="text-primary hover:underline font-medium"
                >
                  Visualizza la versione corrente
                </Link>
              </p>
            )}
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="max-w-4xl mx-auto"
          >
            <div 
              className="prose prose-lg max-w-none
                prose-headings:font-display prose-headings:font-bold prose-headings:text-dark
                prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-4
                prose-p:text-dark-600 prose-p:leading-relaxed
                prose-li:text-dark-600
                prose-strong:text-dark
                prose-ul:my-4 prose-ul:list-disc prose-ul:pl-6
                prose-a:text-primary prose-a:no-underline hover:prose-a:underline"
            >
              {children}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  )
}
